import { TOTAL_CLEAN_ENERGY } from "Constants/GameData";
import { CardObjectType } from "Models/Card";

export class GameHelper {

    static userTurn: string = 'Your Turn';
    static computersTurn: string = 'Computer\'s Turn';
    static shuffleMessage: string = 'Shuffling deck. Please wait';

    static calculateCurrentCleanEnergyPercentage(currentCleanEnergy: number) {
        return currentCleanEnergy >= 0 ? currentCleanEnergy / TOTAL_CLEAN_ENERGY * 100 : 0;
    }

    static setGameData(gameData: any) {
        localStorage.setItem('game_data', JSON.stringify(gameData));
    }

    static getGameData() {
        const token = localStorage.getItem('game_data');
        return token? JSON.parse(token) : null;
    }

    static clearGameData() {
        localStorage.removeItem('game_data');
    }    

    static setPlayerInfo(playerInfo: any) {
        localStorage.setItem('player_info', JSON.stringify(playerInfo));
    }

    static getPlayerInfo() {        
        const token = localStorage.getItem('player_info');
        return token? JSON.parse(token) : null;
    }

    static updatePlayerInfo(data: any) {
        const t = this.getPlayerInfo();
        const newToken = Object.assign({}, t, data);
        this.setPlayerInfo(newToken);
    }

    static clearPlayerInfo() {
        localStorage.removeItem('player_info');
    } 

    static randomGenerator(min: number, max: number) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    static calculatePointPlayedFromEnergyPercentage(prevCleanEnergy: number, currentCleanEnergy: number) {
        const diff: number = Math.abs(currentCleanEnergy - prevCleanEnergy);
        return Math.ceil((diff * TOTAL_CLEAN_ENERGY) / 100) % 100 === 0 ? Math.ceil((diff * TOTAL_CLEAN_ENERGY) / 100) : Math.floor((diff * TOTAL_CLEAN_ENERGY) / 100);
    }
    static Shuffle(times: number, Cards: CardObjectType[]) {
        while (times--) {
            for (let i = Cards?.length - 1; i > 0; i--) {
                let j = (Math.floor(Math.random() * 10000000000)) % (i + 1);
                let temp = Cards[i];
                Cards[i] = Cards[j];
                Cards[j] = temp;
            }
        }
        return Cards;
    };

    static quizCorrectAnswerMessage(player: string, points: number) {
        if(player === '0') {
            return `You played an energy tip card and answered correctly. You received ${points} kW of clean energy!`;
        } else {
            return `Computer played an energy tip card and answered correctly. Computer received ${points} kW of clean energy!`;
        }
    }

    static quizWrongAnswerMessage(player: string, points: number) {
        if(player === '0') {
            return `You played an energy tip card and answered incorrectly. You received ${points} kW of dirty energy!`;
        } else {
            return `Computer played an energy tip card and answered incorrectly. Computer received ${points} kW of dirty energy!`;
        }
    }

    static cleanEnergyAddedToGrid(player: string, points: number) {
        if(player === '0') {
            return `You received ${points} kW of clean energy!`;
        } else {
            return `Computer received ${points} kW of clean energy!`;
        }
    }

    static dirtyEnergyThrownToGrid(player: string, points: number) {
        if(player === '0') {
            return `You threw ${points} kW of dirty energy to your opponent!`;
        } else {
            return `Computer threw ${points} kW of dirty energy to you!`;
        }
    }

    static getQueryParamsObject(extraParam?: any) {
        const urlParams = new URLSearchParams(window.location.search);
        const entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        const params: any = GameHelper.paramsToObject(entries);
        if (extraParam) {
            return { ...params, ...extraParam };
        } else {
            return params;
        }        
    }

    static paramsToObject = (entries: any) => {
            const result: any = {};
            for(const [key, value] of entries) { 
            result[key] = value;
            }
            return result;
    }

    static checkObjectEquals = ( x: any, y: any ) => {
        if ( x === y ) return true;
          // if both x and y are null or undefined and exactly the same
      
        if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) return false;
          // if they are not strictly equal, they both need to be Objects
      
        if ( x.constructor !== y.constructor ) return false;
          // they must have the exact same prototype chain, the closest we can do is
          // test there constructor.
      
        for ( var p in x ) {
          if ( ! x.hasOwnProperty( p ) ) continue;
            // other properties were tested using x.constructor === y.constructor
      
          if ( ! y.hasOwnProperty( p ) ) return false;
            // allows to compare x[ p ] and y[ p ] when set to undefined
      
          if ( x[ p ] === y[ p ] ) continue;
            // if they have the same strict value or identity then they are equal
      
          if ( typeof( x[ p ] ) !== "object" ) return false;
            // Numbers, Strings, Functions, Booleans must be strictly equal
      
          if ( ! GameHelper.checkObjectEquals( x[ p ],  y[ p ] ) ) return false;
            // Objects and Arrays must be tested recursively
        }
      
        for ( p in y )
          if ( y.hasOwnProperty( p ) && ! x.hasOwnProperty( p ) )
            return false;
              // allows x[ p ] to be set to undefined
      
        return true;
    }
}